export const LanguageCode = {
  Tr: 'tr',
  En: 'en',
} as const;

export type LanguageCodeValue = (typeof LanguageCode)[keyof typeof LanguageCode];

export const SUPPORTED_LANGUAGES: LanguageCodeValue[] = [LanguageCode.Tr, LanguageCode.En];

/** Narrows an i18next language tag (`en`, `en-US`, undefined) to a supported code, Turkish when
 *  it is not one of them: the fallback language of the app. */
export function toSupportedLanguage(language: string | undefined): LanguageCodeValue {
  const base = language?.split('-')[0];
  return SUPPORTED_LANGUAGES.find((code) => code === base) ?? LanguageCode.Tr;
}

export const LANGUAGE_STORAGE_KEY = 'beetegre_lang';
